import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Modal, Typography } from '@material-ui/core';
import FormGiornaliero from '../manualecomponents/dettaglio_procedura/FormGiornaliero';
import FormMensile from '../manualecomponents/dettaglio_procedura/FormMensile';
import FormSettimanale from '../manualecomponents/dettaglio_procedura/FormSettimanale';
import FormAnnuale from '../manualecomponents/dettaglio_procedura/FormAnnuale';
import ActionButton from '../../../components/ActionButton';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: '20px',
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    width: '70%',
    maxWidth: '1500px',
    maxHeight: '85vh',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  modalContent: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    overflowY: 'auto',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    width: '100%',
    paddingTop: theme.spacing(2),
  },
});

class ModalSelezioneOrarioScheda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orariDisponibili: [
        '0:00',
        '1:00',
        '2:00',
        '3:00',
        '4:00',
        '5:00',
        '6:00',
        '7:00',
        '8:00',
        '9:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
      ],
      colonneOrario: [],
      altraCadenza: '',
      selectedOrario: null,
      cadenze: this.props.cadenze,
    };
  }

  componentDidMount = () => {};

  onChange = () => {};

  onAddCadenza = (cadenza) => {
    let arrayOfCadenze = [...this.state.cadenze];
    arrayOfCadenze.push(cadenza);
    arrayOfCadenze.forEach((cadenza) => {
      cadenza['schedaId'] = this.props.schedaId;
    });
    this.setState({
      cadenze: arrayOfCadenze,
    });
  };

  onDeleteCadenza = (selectedOrario) => {
    let arrayOfCadenze = [...this.state.cadenze];
    arrayOfCadenze.splice(selectedOrario, 1);
    this.setState({
      cadenze: arrayOfCadenze,
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <Typography style={{ align: 'center', fontSize: 30, flexShrink: 0 }}>
            Orario del controllo
          </Typography>
          <div className={classes.modalContent}>
            {this.props.cadenza === 'GIORNALIERA' ? (
              <FormGiornaliero
                theme={this.props.theme}
                onChange={this.onChange}
                onAddCadenza={this.onAddCadenza}
                cadenze={this.state.cadenze}
                onDeleteCadenza={this.onDeleteCadenza}
              />
            ) : null}
            {this.props.cadenza === 'SETTIMANALE' ? (
              <FormSettimanale
                theme={this.props.theme}
                onChange={this.onChange}
                onAddCadenza={this.onAddCadenza}
                cadenze={this.state.cadenze}
                onDeleteCadenza={this.onDeleteCadenza}
              />
            ) : null}
            {this.props.cadenza === 'MENSILE' ? (
              <FormMensile
                theme={this.props.theme}
                onChange={this.onChange}
                onAddCadenza={this.onAddCadenza}
                cadenze={this.state.cadenze}
                onDeleteCadenza={this.onDeleteCadenza}
              />
            ) : null}
            {this.props.cadenza === 'ANNUALE' ? (
              <FormAnnuale
                theme={this.props.theme}
                onChange={this.onChange}
                onAddCadenza={this.onAddCadenza}
                cadenze={this.state.cadenze}
                onDeleteCadenza={this.onDeleteCadenza}
              />
            ) : null}
          </div>
          <div className={classes.buttonWrapper}>
            <ActionButton
              label="Chiudi"
              secondaryButton
              onClick={this.props.onClose}
            />
            <ActionButton
              label="Salva"
              onClick={() =>
                this.props.setCadenzeToControllo(this.state.cadenze)
              }
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalSelezioneOrarioScheda.propTypes = {
  cadenza: PropTypes.string.isRequired,
  cadenze: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setCadenzeToControllo: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles)(ModalSelezioneOrarioScheda);
